<mat-toolbar class="d-flex flex-space-between mat-elevation-z3" color="primary">
    <button [routerLink]="['/timeline']" aria-label="Home" mat-icon-button matTooltip="Home">
        <img alt="Virtual Memory Box Logo" height="24" ngSrc="assets/images/vmb.svg" width="24">
    </button>
</mat-toolbar>
@if (settings) {
    <main>
        <div class="mediumContainer">
            <div class="d-flex justify-content-center">
                <h1 class="mx-auto">Terms & Conditions</h1>
            </div>
            @if (!termsDynamic && settings) {
                <div>
                    <h2 class="text-center"><strong>{{ settings.authority_name }}, Children's Social Care</strong></h2>
                    <h3 class="text-center"><strong>Virtual Memory Box Terms & Conditions </strong></h3>
                    <p>Unacceptable or inappropriate use of Virtual Memory Box exposes the user,
                        the {{ settings.is_raa ? 'RAA' : 'Council' }} and
                        contents to risks which could damage the {{ settings.is_raa ? 'RAA' : 'Council' }}&rsquo;s
                        reputation, harm people and cause legal
                        issues.
                        Access and use of Virtual Memory Box and all information contained in and relating to is
                        monitored,
                        therefore privacy cannot be assumed. This policy applies to all persons using Virtual Memory Box
                        and it
                        is the responsibility of all users to accept the terms of this policy and seek guidance if
                        unsure.</p>
                    <p>The {{ settings.is_raa ? 'RAA' : 'council' }} retains all rights to grant, remove and limit
                        access to the Virtual Memory Box in
                        order to protect it, its contents and its account holders.</p>
                    <h4 class="mt-10 mb-0">1. Information Confidentiality</h4>
                    <p>Personal and Special Category information must not be:</p>
                    <ol class="mb-20" type="a">
                        <li>Disclosed to or discussed with unauthorised persons.</li>
                        <li>Removed and Stored on portable media such as CD, DVD or USB storage devices; unless
                            authorised to do so and encrypted.
                        </li>
                        <li>{{ settings.is_raa ? 'RAA Users' : 'Council employees' }} must not store or transfer files
                            and information on non-{{ settings.is_raa ? 'RAA' : 'Council' }} equipment or send via
                            non-{{ settings.is_raa ? 'RAA' : 'Council' }} or personal e-mail accounts.
                        </li>
                        <li>Used to gain access to or amend information / others Virtual Memory Boxes which you are not
                            authorised to do so.
                        </li>
                        <li>Used to access any other than your own records or those of any person linked to you through
                            Children's Social Care employee contact or where you are responsible for the child'&rsquo;'s
                            current care.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">2. Legal Obligations</h4>
                    <p>All users must:</p>
                    <ol class="mb-20" type="a">
                        <li>Adhere to the Data Protection Act 2018 and the General Data Protection Regulation
                            (GDPR). {{ settings.is_raa ? 'Users' : 'Staff' }} should refer to
                            the {{ settings.is_raa ? 'RAA' : 'Council' }}'s Data Protection Policy.
                        </li>
                        <li>Comply with applicable legislation and if you are unsure seek guidance.</li>
                        <li>Not use the Virtual Memory Box to engage in any illegal activity.</li>
                        <li>Only share personal and special category information using approved secure methods directly
                            via the Virtual Memory Box.
                        </li>
                        <li>Use only licensed software and abide by copyright and licensing laws. Permission must be
                            obtained to use licensed music, video, TV programmes or website downloads or to digitise.
                        </li>
                    </ol>

                    <p>It is a criminal offence to:</p>
                    <ol class="mb-20" start="6" type="a">
                        <li>Knowingly or recklessly disclose / process personal information without authorisation.</li>
                        <li>Use information for a purpose other than for which it was originally intended.</li>
                        <li>Re-identify individuals from data that has been anonymised.</li>
                        <li>Alter or prevent the disclosure of personal data that has been subject to an access
                            request.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">4. Inappropriate Material</h4>
                    <ol class="mb-20" type="a">
                        <li>{{ settings.is_raa ? 'Users' : 'Carers' }} should ensure that
                            <span><strong>all</strong></span> uploaded content for children they are responsible for is
                            appropriate and fully meets the requirements of this policy.
                        </li>
                        <li>It is strictly prohibited to attempt to access, view, send, circulate, comment, tag or store
                            material that is defined as inappropriate material at any time.
                        </li>
                        <li>Inappropriate use of language, tags and files should be deemed as inappropriate materials.
                        </li>
                    </ol>

                    <p>Inappropriate Content (includes but not limited to):</p>
                    <ul class="mb-20">
                        <li>Exposure to inappropriate content, including online pornography, unsuitable age ratings in
                            films and games etc, substance abuse
                        </li>
                        <li>promoting harmful behaviours</li>
                        <li>Hate content</li>
                        <li>Grooming (sexual exploitation, radicalisation etc.)</li>
                        <li>Online bullying in all forms</li>
                        <li>Social or commercial identity theft, including passwords</li>
                        <li>Aggressive behaviours such as bullying and intimidation</li>
                        <li>Privacy issues, including disclosure of personal information</li>
                        <li>Negative Health and well-being including online gambling, body image, internet or gaming;
                        </li>
                        <li>indecent images of any type</li>
                        <li>Copyright and intellectual property theft &ndash; such as music and film.</li>
                    </ul>

                    <h4 class="mt-10 mb-0">5. Workspace Security</h4>
                    <ol class="mb-20" type="a">
                        <li>Always log out of the Virtual Memory Box and other ICT equipment when not in use, or lock
                            screens.
                        </li>
                        <li>When working in public environments (trains, cafes etc) be mindful of people around you and
                            whether they can see personal or confidential information on your screen or hear you
                            talking.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">6. Login information and Passwords</h4>
                    <ol class="mb-20" type="a">
                        <li>You are responsible for all activity under your login, which is monitored.</li>
                        <li>Never write down or share your login or password with anyone,
                            including {{ settings.is_raa ? 'users' : 'employees' }} of {{ settings.authority_name }} or
                            partner Virtual Memory Box Limited.
                        </li>
                        <li>Passwords should be strong, including a mix of letters, numbers and special characters for
                            maximum security.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">9. Cyber Security</h4>
                    <ol class="mb-20" type="a">
                        <li>You are responsible for checking files are not corrupt and any attachments are scanned for
                            viruses before uploading.
                        </li>
                        <li>If you believe a file is suspicious, do not click any links, download any attachments, enter
                            any type of information or data (personal details, passwords, financial information etc.)
                            and contact to the Virtual Memory Box email and report it immediately.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">10. ICT &amp; Information Security Incidents</h4>
                    <ol class="mb-20" type="a">
                        <li>All security incidents, perceived weaknesses or suspected data breaches must be reported
                            to {{ settings.authority_name }} immediately. {{ settings.is_raa ? 'Users' : 'Carers' }}
                            should contact the Virtual Memory Box
                            email{{ settings.is_raa ? '.' : '; employees should contact Information Security directly.' }}
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">12. Personal Equipment</h4>
                    <ol class="mb-20" type="a">
                        <li>{{ settings.is_raa ? 'Users' : 'Employees' }} of {{ settings.authority_name }} should only
                            use authorised personal IT equipment. Memory sticks, mobile phones and other devices can be
                            used for {{ settings.is_raa ? 'RAA' : 'Council' }} business but must not be attached
                            to {{ settings.is_raa ? 'RAA' : 'Council' }} systems or used to take unauthorised photos,
                            videos or audio recordings at work.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">13. Policy Compliance &amp; Disciplinary</h4>
                    <ol class="mb-20" type="a">
                        <li>{{ settings.is_raa ? 'Users' : 'Employees' }} - Policy breaches will be taken seriously and
                            may be considered as misconduct or gross misconduct resulting in disciplinary and in some
                            cases legal action.
                        </li>
                        <li>All other users - Policy breaches will be taken seriously and necessary remedial actions
                            will be put in place to protect the Virtual Memory Box, its contents and legal requirements
                            this may include, but is not be limited to, removal of access to files and folders, removal
                            of files and comments and other limitations and in some cases legal action may be
                            considered.
                        </li>
                    </ol>

                    <h4 class="mt-10 mb-0">14. Advice, assistance and support</h4>
                    <ol class="mb-20" type="a">
                        <li>If you require further information, advice or guidance please {{ settings.authority_name }}
                            via the Virtual Memory Box email where {{ settings.is_raa ? 'users' : 'employees' }} will be
                            happy to help.
                        </li>
                    </ol>
                </div>
            }
            <div [innerHTML]="termsDynamic" aria-label="Dynamically loaded terms content" role="document">
            </div>
            @if (this.user && !this.user.agreed_tos) {
                <div class="w-100 text-center mb-10">
                    <button (click)="acceptTerms()" (keyup.enter)="acceptTerms()" color="primary" mat-raised-button>
                        Accept Terms
                    </button>
                </div>
            }
            @if (this.user && this.user.agreed_tos) {
                <div class="w-100 text-center mb-10">
                    <button (click)="navigateBack()" (keyup.enter)="navigateBack()" color="primary" mat-raised-button>
                        Back to dashboard
                    </button>
                </div>
            }
        </div>
    </main>
}
<app-footer></app-footer>
